import { takeEvery, put, call } from "redux-saga/effects"

import { getProductAdminProfile, productAdminLogin } from "helpers/backend_helper"
import { loginProductAdminSuccess, apiError, getProductAdminProfileSuccess } from "./actions"
import { LOGIN_PRODUCT_ADMIN } from "./actionTypes"
import { isEmpty } from "lodash"

function* loginProductAdmin({ payload: { productAdmin, history } }) {
    try {
        console.log("inside loginProductAdmin saga::::::::;")
        const response = yield call(productAdminLogin, {
            username: productAdmin.username,
            password: productAdmin.password,
            groupCode: productAdmin.groupCode,
            userType: productAdmin.userType,
            userCaptcha: productAdmin.userCaptcha,
            captchaToken: productAdmin.captchaToken
        })
        console.log(response)
        yield put(loginProductAdminSuccess(response))
        sessionStorage.setItem("authUser", JSON.stringify(response))
        // const productAdminProfile = yield call(getProductAdminProfile)
        //yield put(getProductAdminProfileSuccess(productAdminProfile))
        let isAdmin = false;
        let user = false;
        if (response !== undefined && !isEmpty(response.authorities)) {
            let authority = response.authorities[0].authority
            console.log(authority)
            if (authority === 'ROLE__ASTRO_PRODUCTADMIN') {
                isAdmin = true;
            }
        }

        // if (productAdminProfile !== undefined && productAdminProfile.role !== undefined) {
        //     if (productAdminProfile.role === 'ROLE__ASTRO_PRODUCTADMIN') {
        //         isAdmin = true;
        //     }
        // }
        sessionStorage.setItem("userRoles", JSON.stringify({
            productAdmin: isAdmin, user
        }));
        history.push("/dashboard")
    } catch (error) {

        if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
            if (isEmpty(error.response.data.message)) {
                yield put(apiError(error.response.data))
            } else {
                yield put(apiError(error.response.data.message))
            }
        } else {
            yield put(apiError(error.message))
        }
    }
}

function* logoutProductAdmin({ payload: { history } }) {
    try {
        sessionStorage.removeItem("authUser")
        sessionStorage.removeItem("userProfile")
        history.push("/product/login")
    } catch (error) {
        yield put(apiError(error))
    }

}

function* productAdminAuthSaga() {
    yield takeEvery(LOGIN_PRODUCT_ADMIN, loginProductAdmin)
    yield takeEvery(LOGIN_PRODUCT_ADMIN, logoutProductAdmin)
}

export default productAdminAuthSaga